module.exports = global["MJO"] = require("-!C:\\build\\master\\mjo\\mjo-frontend\\node_modules\\babel-loader\\lib\\index.js??ref--4!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?MJO!./src/blocks/index.js-exposed
// module id = 554
// module chunks = 0 1